import { render, staticRenderFns } from "./UjianFinishHasil.vue?vue&type=template&id=240f76cc&scoped=true"
import script from "./UjianFinishHasil.vue?vue&type=script&lang=js"
export * from "./UjianFinishHasil.vue?vue&type=script&lang=js"
import style0 from "./UjianFinishHasil.vue?vue&type=style&index=0&id=240f76cc&prod&scoped=true&lang=css"
import style1 from "./UjianFinishHasil.vue?vue&type=style&index=1&id=240f76cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f76cc",
  null
  
)

export default component.exports